import { Spacing, Text as TextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const ConnectionErrorContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Text = styled(TextComponent)`
  margin-top: ${Spacing.S16};
`

export const MenetoErrorText = styled(TextComponent)`
  text-align: center;
`
